export function calculateBillDeltaPct(current: number, prior: number): number {
  if (prior === 0) return 0;
  return ((current - prior) / prior) * 100;
}

export function calculateMeterKwh(costSharePct: number, aggregateKwh: number): number {
  return Math.round((costSharePct / 100) * aggregateKwh);
}

export function calculateMeterCost(costSharePct: number, total: number): number {
  return Math.round((costSharePct / 100) * total * 100) / 100;
}

export function calculatePortfolioTotal(accounts: { currentBillAmount: number }[]): number {
  return accounts.reduce((sum, a) => sum + a.currentBillAmount, 0);
}

export function calculateEnergyCharge(rate: number, usageKWh: number): number {
  return Math.round(rate * usageKWh * 100) / 100;
}

export function calculateDemandCharge(demandKW: number, ratePerKW = 15): number {
  return demandKW * ratePerKW;
}

export function calculateMeterSharePct(costSharePct: number | undefined, totalMeters: number): number {
  return costSharePct !== undefined
    ? Math.round(costSharePct * 100)
    : Math.round(100 / totalMeters);
}
